package de.katoonerie.content

import androidx.compose.runtime.Composable
import app.softwork.routingcompose.NavLink
import de.katoonerie.components.Prose
import de.katoonerie.components.QuestionMarkCircle
import org.jetbrains.compose.web.dom.Br
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun NotFound() {
    Div {
        Div(attrs = {
            classes("mt-24", "mb-10", "mx-auto", "w-32", "h-32")
        }) {
            QuestionMarkCircle()
        }
        Prose(attrs = { classes("prose-lg", "mx-auto", "text-center") }) {
            P {
                Text("Ups! Diese Seite wurde nicht gefunden.")
                Br()
                NavLink(to = "/") {
                    Text("Zurück zur Startseite")
                }
            }
        }
    }
}
